/**
 * Set email encode in localStorage
 * @param email
 */
export const persistPartnerAgreement = (email) => {
  try {
    if (email !== null && email !== undefined && email !== "") {
      let encodedEmail = window.btoa(email);
      localStorage.setItem("pdfId", encodedEmail);
    }
  } catch (err) {
    // manage this error
  }
};

/**
 * get the email decode from localStorage
 * @return {*}
 */
export const getPartnerAgreementPersist = () => {
  try {
    const encodedEmail = localStorage.getItem("pdfId");
    if (
      encodedEmail !== null &&
      encodedEmail !== undefined &&
      encodedEmail !== ""
    ) {
      return window.atob(encodedEmail);
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

/**
 * get the code from localStorage
 * @return {*}
 */
export const getDownloadCode = () => {
  try {
    const encodedEmail = localStorage.getItem("pdfId");
    if (
      encodedEmail !== null &&
      encodedEmail !== undefined &&
      encodedEmail !== ""
    ) {
      return encodedEmail;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/modules/AppCore/js/persistEmail.js